/* eslint-disable react/destructuring-assignment */
/* eslint-disable  no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Formio, Components } from '@formio/react';
import { cloneDeep, isEqual } from 'lodash';
import { QuoteProgress, activateTheme, themes, LoadingIndicators } from '../canvasComponents/index';
import { FormattedMessage, useIntl } from 'react-intl';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import messages from '../pages/Claim/messages';
import components from './Custom';
// redux
import { claimsDataSelector, gwClaimsDataSelector, selectUpdatedClaimSelector, selectCreatedShellClaimSelector } from '../redux/Claims/selector';
import { authenticationDataSelector } from '../redux/Authentication/selector';
import { updateClaim, createShellClaim, submitClaim, clearShellClaimDuplicated } from '../redux/Claims/actions';
import { policyDetailsSelector } from '../redux/PolicyDetails/selector';
import { getPolicyDetails } from '../redux/PolicyDetails/actions';
import useLeavingPageHandler from '../hooks/useLeavingPageHandler';
// utils
import { getRouteUrl, setPage, hasLossCause, reorderPages, getClaimType } from './utils';
import { getNewClaimStatus } from '../utils/claim/claimStatusHandler';
import { checkIfClaimIsAssisted, claimAssistedListener, closeClaimAssistedListener } from '../utils/claim/checkIfClaimIsAssisted';
import updateFormData from '../utils/common/updateFormData';
import convertSubmissionObjectToGW from '../utils/common/convertSubmissionObjectToGW';
import { selectPolicy, getRiskUnit, getPropertyType } from '../utils/policy/selectPolicy';
import LeavingTooSoonPopUp from '../components/LeavingTooSoonPopUp/LeavingTooSoonPopUp';
import { steps } from '../utils/progressbar/progressbarSteps';

// constants
import * as types from '../utils/constants/claimStatusTypes';
import * as events from '../utils/constants/formEvents';
// form object
import mainForm from './main-form.json';
// sass
import '../css/components/Formio/Formio.scss';
// config
import { FEbaseURL } from '../config';
// other components
import Services from '../pages/Services/services';
import FatalityPopUp from '../components/FatalityPopup/FatalityPopUp';
import UnibanPopUp from '../components/UnibanPopup/UnibanPopup';
import IncidentAlreadyClaimedPopUp from '../components/IncidentAlreadyClaimedPopUp/IncidentAlreadyClaimedPopUp';
import SomethingElsePropertyPopUp from '../components/SomethingElsePropertyPopUp/SomethingElsePropertyPopUp';
// Analytics
import * as FS from '../analytics/fullstory';
import * as GA from '../analytics/googleanalytics';
// Translations
import TranslationsEN from '../translations/en.json';
import TranslationsFR from '../translations/fr.json';
import IdealUserPopUp from '../components/IdealUserPopUp/IdealUserPopUp';
import { validateAndSanitizeData } from './Custom/utils/validateAndSanitizeData';
// Data paths related to notes
import { additionalDetailsPaths, reporterPaths, condoPaths } from '../utils/constants/notePaths';

Formio.setBaseUrl(FEbaseURL);
Formio.setProjectUrl(FEbaseURL);
Formio.setAuthUrl(FEbaseURL);
Formio.registerPlugin({
  preRequest(requestArgs) {
    return new Promise((resolve) => {
      requestArgs.url = `${requestArgs.formio.formUrl}.json`;
      resolve();
    });
  },
});

Components.setComponents(components);

function FormioComponents(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSaved, setIsSaved] = useState(true); // Set the isSaved flag to true to trigger the correct behavior of Interval useEffect
  const [isFormioSubmitted, setIsFormioSubmitted] = useState(false);
  const [isRendered, setIsRendered] = useState(false);
  const [claimAutoSaved, setClaimAutoSaved] = useState(false); // is used to determine which msg to show for ideal pop up modal if data is auto saved or not
  const [isSaveContinueLater, setIsSaveContinueLater] = useState(false);
  const [riskUnit, setRiskUnit] = useState({});
  const [eligibleService, setEligibleService] = useState([]);
  const [uberAmount, setUberAmount] = useState();
  const [lossDetailsConfirmed, setLossDetailsConfirmed] = useState(false);
  const [isResumeClaim, setIsResumeClaim] = useState(false);
  const [hasPolicyDetails, setHasPolicyDetails] = useState(false);
  const [pageIsSet, setPageIsSet] = useState(false);
  const [isAssisted, setIsAssisted] = useState(false);
  const [onNext, setOnNext] = useState(() => () => {});
  // modal states
  const [isFatalityModalOpen, setFatalityModalOpen] = useState(false);
  const [isUnibanModalOpen, setUnibanModalOpen] = useState(false);
  const [isIncidentAlreadyClaimedOpen, setIsIncidentAlreadyClaimedOpen] = useState(false);
  const [isPropertyLossCauseSomethingElse, setIsPropertyLossCauseSomethingElse] = useState(false);
  const [render, setRender] = useState(false);
  const intl = useIntl();

  // Progress Bar Variables
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageLabel, setCurrentPageLabel] = useState(null);

  // Notes content
  let updateAdditionalDetailsNote = false;
  let updateReporterNote = false;
  let updateCondoNote = false;
  let abDriver = {};

  let claimData = null;
  let formClaimData = null;
  let currentClaimData = null;
  let claimStatus;
  let isReadOnly;
  let editedFormData;
  let wasAnyFatalityModalOpen = false;
  let lastVisitedPage = [];
  let shellClaimId = '';
  let somethingElseSelected = false;

  const { claimId, authentication } = props;
  const { sonnetAddressBookUid, preferredLang } = authentication;
  const createShellClaimSelector = props.createShellClaim;

  // init GTM
  const sendDataToGTM = useGTMDispatch();

  const currentClaim = props.claimData || null;
  // Custom Hook to prevent the user to leave the page on closing the tab/window
  const { isLeavingSoSoonPopUpOpen, setIsLeavingSoSoonPopUpOpen } = useLeavingPageHandler(claimData?.claim_type?.claim_type || 'Vehicle', currentPageLabel);

  const submitHandler = (cid) => {
    if (currentClaim?.submittedData?.lossDetailsConfirmed && !isFormioSubmitted) {
      claimStatus = events.FORM_EVENT_SUBMITTED;
      // send fullstory and google analytics event
      sendDataToGTM(GA.sendEventData('submitClaim', currentClaim, claimStatus));
      FS.sendEventData(currentClaim, claimStatus);
      dispatch(submitClaim(cid));
    }
  };

  // loading data when resuming a claim
  if (currentClaim) {
    claimStatus = currentClaim.digitalFNOLStatus;
    isReadOnly = currentClaim.locked;
    shellClaimId = currentClaim.gwClaimId;

    const claimNumber = window.sessionStorage.getItem('claimNumber');
    if (!claimNumber || claimNumber === 'cdsClaimNumber' || claimNumber === 'gw-claim-number' || claimNumber === 'null') {
      window.sessionStorage.setItem('claimNumber', currentClaim.gwClaimNumber);
    }
    window.sessionStorage.setItem('claimId', currentClaim.claimId);

    if (currentClaim?.submittedData) {
      if (currentClaim?.lossDetailsConfirmed && !isFormioSubmitted) {
        setIsFormioSubmitted(true);
      }
      claimData = { ...currentClaim.submittedData };
      currentClaimData = { ...currentClaim };
      formClaimData = { ...currentClaim.submittedData };
      if (formClaimData.property?.data?.lossCause?.value === 'other') {
        somethingElseSelected = true;
      } else {
        somethingElseSelected = false;
      }
      lastVisitedPage = (claimStatus !== types.CLAIM_STATUS_SUBMITTED && claimData.lastVisitedPage) && claimData.lastVisitedPage ? [...claimData.lastVisitedPage] : [];
    }
  }

  // GWclaim id
  const [gwclaimId, setGwclaimId] = useState(shellClaimId);

  const updateURL = () => {
    const claimType = claimData?.claim_type?.claim_type || 'Vehicle';
    if (!isFormioSubmitted) {
      window.history.pushState(null, window.location.pathname, `#/${getRouteUrl(currentPageLabel, claimType) || ''}`);
    }
  };

  useEffect(() => {
    updateURL();
  }, [currentPage, currentPageLabel]);

  useEffect(() => {
    activateTheme(themes.sonnet);

    if (!isResumeClaim && lastVisitedPage?.length > 0) {
      setIsResumeClaim(true);
    }
  }, []);

  useEffect(() => {
    if (isResumeClaim && !hasPolicyDetails && formClaimData.lossDate?.value) {
      dispatch(getPolicyDetails(formClaimData.lossDate?.value));
    }
  }, [isResumeClaim]);

  useEffect(() => {
    if (props.policyDetails.data?.length && !hasPolicyDetails) {
      setHasPolicyDetails(true);
    }
  }, [props.policyDetails.data]);

  // Change formio's next button label and design on 'Connect with us' property page
  useEffect(() => {
    // Scroll to the page top
    setTimeout(() => {
      document.getElementsByClassName('app')[0].scrollTop = 0;
    }, 100);
    if (document.querySelector('.form-step-title h1')?.innerText === 'Connect with us' || document.querySelector('.form-step-title h1')?.innerText === 'Pour nous joindre') {
      if (document.querySelector('.btn.btn-primary.btn-wizard-nav-next')) {
        const continueBtn = document.querySelectorAll('.btn.btn-primary.btn-wizard-nav-next')[document.querySelectorAll('.btn.btn-primary.btn-wizard-nav-next').length - 1];
        continueBtn.innerText = intl.formatMessage({ id: 'Continue claim & connect later', defaultValue: 'Continue claim & connect later' });
        continueBtn.classList.remove('btn-primary');
        continueBtn.classList.add('btn-secondary');
        continueBtn.classList.add('btn-secondary-continue-claim');
        const startChatBtn = document.querySelector('.formio-component-openChatbot button');
        startChatBtn?.classList.add('open-chatbot-btn--no-margin');
      }
    }
  }, [currentPage]);

  useEffect(() => {
    setRender(true);
    // If claim has updated, then claimData will update with the last changes
    if (Object.keys(props.updatedClaim.data).length) {
      claimData = { ...props.updatedClaim.data };
    }

    // Navigate to /dashboard if "Save and Continue Later" button is clicked
    if (!props.updatedClaim.loading && isSaveContinueLater) {
      navigate('/dashboard');
    }
  }, [props.updatedClaim]);

  useEffect(() => {
    const thisClaim = props.claims.data.find((claim) => claim.claimId === claimId) || null;
    if (thisClaim?.gwClaimId && thisClaim.gwClaimId !== gwclaimId) {
      setGwclaimId(thisClaim.gwClaimId);
    }

    const claimServicesExt = thisClaim?.claimServices;
    // Setting claimServices after submitting a claim
    if (claimServicesExt && Object.keys(claimServicesExt).length) {
      setEligibleService(Object.keys(claimServicesExt).filter((item) => claimServicesExt[item] === true));
      claimServicesExt?.isUberEligible === true && setUberAmount(claimServicesExt?.voucherAmount);
    }
    if (thisClaim?.lossDetailsConfirmed && !lossDetailsConfirmed) {
      setLossDetailsConfirmed(true);
    }
  }, [props.claims.data]);

  const checkIfClaimIsDuplicated = (pageCurrent, submission, next) => {
    if (pageCurrent.path === 'startPage') {
      triggerCreateShellClaim(submission).then(() => {
        setOnNext(() => (_error) => { _error ? next(_error) : next(); });
      });
    } else {
      next();
    }
  };

  useEffect(() => {
    if (createShellClaimSelector.duplicated) {
      setIsIncidentAlreadyClaimedOpen(true);
      onNext({ message: 'error: The claim is duplicated' });
    } else if (!createShellClaimSelector.loading && !createShellClaimSelector.error.error) {
      onNext();
    }
  }, [createShellClaimSelector.loading]);

  /**
   * Start timer for the saveBackup method (1 minute - 60000 / 20 seconds - 20000)
   * Timer resets on every isSaved change
   */
  useEffect(() => {
    let interval;
    if (isRendered) {
      const continueButton = document.querySelector('.formio-wizard-nav-container.list-inline');
      const saveContinueLaterButton = document.querySelector('.formio-component-button.save-continue-later');
      if (continueButton) {
        window.addEventListener(
          'click',
          (e) => scrollToExistingErrors(e),
        );
        if (saveContinueLaterButton) {
          saveContinueLaterButton.parentNode.insertBefore(continueButton, saveContinueLaterButton);
        }
      }
    }
    if (isFormioSubmitted === false) {
      const invisibleButton = document.querySelector('.invisibleButton button');
      if (invisibleButton !== null) {
        interval = setInterval(() => {
          invisibleButton.click();
        }, 300000);
        setIsSaved(false);
        setClaimAutoSaved(true);
      }
    }
    return () => {
      clearInterval(interval);
      window.removeEventListener('click', (e) => scrollToExistingErrors(e));
    };
  }, [isSaved, isRendered]);

  /**
  * This event opens a communication channel between BFF and the frontend.
  * The channel is closed when the user leaves the claim.
  */
  useEffect(() => {
    const checkAssited = async () => { await checkIfClaimIsAssisted(gwclaimId, (assisted) => setIsAssisted(assisted)); };

    if (gwclaimId && gwclaimId !== 'gw-claim-id') {
      checkAssited(); // check if claim is assisted when resuming claim
      claimAssistedListener(gwclaimId, (assisted) => setIsAssisted(assisted)); // open eventSource to listen to changes in claim assisted flag
      return () => {
        closeClaimAssistedListener();
      };
    }
  }, [gwclaimId]);

  useEffect(() => {
    if (isAssisted === true) {
      navigate('/dashboard');
    }
  }, [isAssisted]);

  window.addEventListener('reviewEdit', (e) => {
    // Scroll to the page top
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    if (e?.detail?.key === 'setPage' && e.detail.page) {
      const findReviewPageIndex = lastVisitedPage.findIndex((page) => page.startsWith('review'));
      if (findReviewPageIndex >= 0) {
        lastVisitedPage[findReviewPageIndex + 1] = e.detail.page;
      }
    }
  }, false);

  /**
   * Initiate form data and form events
   * @param {Object} instance
   */
  const instanceHandler = (instance) => {
    if (instance) {
      instance.setSubmission({ data: { ...formClaimData } });
      instance.on('nextPage', (e) => updateHandler(e, null, instance, false));
      instance.on('submit', updateHandler);
      instance.on('change', changeHandler);
      instance.once('subWizardsUpdated', (subWizard) => {
        if (isResumeClaim && subWizard) {
          if (lastVisitedPage?.[lastVisitedPage.length - 1]?.includes('_page') || lastVisitedPage?.[lastVisitedPage.length - 1]?.startsWith('review')) { // last visited page is in or after sub wizard form
            if (hasLossCause(currentClaim?.submittedData)) { // check subwizard for data (loss cause because it's the 1st question in all sub wizards)
              subWizard.once('change', async () => {
                if (!pageIsSet && isResumeClaim) {
                  lastVisitedPage = await [...setPage(instance, lastVisitedPage, getClaimType(currentClaim?.submittedData?.claim_type), true, setPageIsSet)];
                }
              });
            } else if (!pageIsSet) {
              setPageIsSet(true);
            }
            for (let i = 0; i < instance.pages.length; i += 1) { // go to subwizard
              instance.setPage(i);
              if (instance?.pages?.[i].path.endsWith('_page1')) {
                break;
              }
            }
          } else {
            lastVisitedPage = [...setPage(instance, lastVisitedPage, getClaimType(currentClaim?.submittedData?.claim_type), false, setPageIsSet)];
          }
        }
      });
    }
  };

  /*
  * Handling errors when the continue button is pressed
  */
  const scrollToExistingErrors = (e) => {
    e.stopImmediatePropagation();
    // Scroll to component when error is triggered
    const firstComponentError = document.querySelector('.form-text.error');
    if (firstComponentError && e.target.className === 'btn btn-primary btn-wizard-nav-next') {
      const errorPosition = firstComponentError.closest('.whatAreTheInjuriesContainer, .peopleInTheOtherVehicles .section, .form-group').offsetTop;
      document.getElementById('app-en-fr').scrollTo({
        top: errorPosition,
        left: 0,
      });
    }
  };

  // Update the boolean value to indicate whether new notes should be created
  const updateFormDataNotesStatus = (formData) => {
    formData.updateAdditionalDetailsNote = updateAdditionalDetailsNote;
    formData.updateReporterNote = updateReporterNote;
    formData.updateCondoNote = updateCondoNote;

    const abDriverFormData = formData?.abonly?.data?.abDriver?.peopleInTheOtherVehiclesInfo?.[0];

    if (abDriverFormData) {
      const newAbDriver = {
        address: abDriverFormData?.address?.value,
        firstName: abDriverFormData?.firstName?.value,
        lastName: abDriverFormData?.lastName?.value,
        number: abDriverFormData?.number?.value,
        license: abDriverFormData?.license,
        insuranceInfo: abDriverFormData?.insuranceInfo,
      };
      formData.updateAbDriverNote = !isEqual(abDriver, newAbDriver);
      abDriver = newAbDriver;
    }
  };

  // Store the state when attributes related to notes are changed.
  const updateNoteState = (path) => {
    if (additionalDetailsPaths.has(path)) {
      updateAdditionalDetailsNote = true;
    } else if (reporterPaths.has(path)) {
      updateReporterNote = true;
    } else if (condoPaths.has(path)) {
      updateCondoNote = true;
    }
  };

  /**
   * Persist data on DB
   * Dispatch method is responsible for update the claim using redux
   * @param {String} sonnetAddressBookUid
   * @param {Object} formData
   * @param {String} status
   */
  const saveToDB = async (user, formData, status, eventType, metadata = {}, lossDetails = false, isServicesUpdate) => {
    if (formData) {
      formData.lastVisitedPage = [...lastVisitedPage];
      if (eventType === events.FORM_EVENT_SAVECONTINUELATER) {
        setIsSaveContinueLater(true);
      }
      const mapping = JSON.parse(window.sessionStorage.getItem('idMapping'));
      if (mapping && Object.keys(mapping).length !== 0) {
        updateFormData(formData, mapping);
      }

      updateFormDataNotesStatus(formData);
      editedFormData = convertSubmissionObjectToGW(formData);
      editedFormData && (editedFormData.digitalFNOLStatus = status === types.CLAIM_STATUS_EXITED ? types.CLAIM_STATUS_CANCELLED : claimStatus);

      const stringifiedFormData = JSON.stringify(formData);
      const stringifiedFormDataGW = JSON.stringify(editedFormData);
      const stringifiedMetadata = JSON.stringify(metadata).replace(/"/g, '\\"');

      // check if update is required
      const isUpdateRequired = ((eventType === events.FORM_EVENT_NEXT_PAGE || eventType === events.FORM_EVENT_SAVECONTINUELATER || eventType === events.FORM_EVENT_SUBMITTED) && !isServicesUpdate);
      if (isUpdateRequired) { // resets flags for notes only after they are created in GW.
        updateAdditionalDetailsNote = false;
        updateReporterNote = false;
        updateCondoNote = false;
      }
      if ((claimStatus === types.CLAIM_STATUS_SUBMITTED || isFormioSubmitted || lossDetailsConfirmed || currentClaim?.lossDetailsConfirmed) && (eventType !== events.FORM_EVENT_SAVECONTINUELATER && eventType !== events.FORM_EVENT_NEXT_PAGE)) {
        return;
      }

      dispatch(updateClaim(claimId, status, stringifiedFormData, stringifiedFormDataGW, isUpdateRequired, preferredLang, stringifiedMetadata, lossDetails, eventType === events.FORM_EVENT_SAVECONTINUELATER));
      setIsSaved(true);
    }
  };

  const activityHandler = (newFormData) => {
    if (newFormData.isAutoClaim) {
      claimData.auto = { data: { ...newFormData } };
    } else if (newFormData.isAbOnlyClaim) {
      claimData.abonly = { data: { ...newFormData } };
    } else if (newFormData.propertyType) {
      claimData.property = { data: { ...newFormData } };
    } else {
      claimData = { ...newFormData };
    }
  };

  /**
   * Method triggered on 'Submit' buttons or custom events
   * Calls saveToDB to persist data according to the button/event triggered
   * @param {Object} event
   * @param {String} eventType
   */
  const updateHandler = async (event, eventType, instance, isServicesUpdate = false) => {
    if (event.page && instance) {
      const seenPages = lastVisitedPage.slice(0, -1);
      lastVisitedPage = [...reorderPages(instance.pages, instance.pages[event.page], seenPages, getClaimType(event.submission?.data?.claim_type))];
      setCurrentPage(event.page + 1);
    }
    if (claimStatus === types.CLAIM_STATUS_INITIATED || claimStatus === types.CLAIM_STATUS_IN_PROGRESS) {
      let newFormData;
      let metadata = {};
      let lossDetails;
      claimStatus = getNewClaimStatus(claimStatus, event, eventType);
      if (eventType === events.FORM_EVENT_PERIODICSAVE || eventType === events.FORM_EVENT_SAVECONTINUELATER || eventType === events.FORM_EVENT_LEAVINGPAGE) {
        newFormData = cloneDeep(event.data);
        if (newFormData?.services) {
          lossDetails = true;
          newFormData = { ...newFormData, lossDetailsConfirmed: true };
        } else {
          lossDetails = false;
        }
      } else if (event.data && claimStatus !== types.CLAIM_STATUS_SUBMITTED) {
        // SUBMIT BUTTON
        setIsFormioSubmitted(true);
        newFormData = event.data;
        metadata = cloneDeep(event.metadata);
        newFormData = { ...newFormData, lossDetailsConfirmed: true };
        lossDetails = true;
      } else {
        // NEXT BUTTON
        eventType = events.FORM_EVENT_NEXT_PAGE;
        newFormData = event.submission.data;
        validateAndSanitizeData(newFormData);
        lossDetails = false;
      }

      if (event.state === events.FORM_EVENT_SUBMITTED) {
        eventType = event.state;
      }

      activityHandler(newFormData);

      // send fullstory and google analytics event
      sendDataToGTM(GA.sendEventData('updateClaim', claimData, claimStatus));
      FS.sendEventData(claimData, eventType);
      await saveToDB(sonnetAddressBookUid, claimData, claimStatus, eventType, metadata, lossDetails, isServicesUpdate);
    }
  };

  /**
   * Trigger create shell claim (if it has not been created yet)
   * @param {Object} event
   */
  const triggerCreateShellClaim = (submission) => new Promise((resolve) => {
    const thePolicy = window.sessionStorage.getItem('thePolicy');
    const policyNumber = thePolicy ? JSON.parse(thePolicy).policyNumber : null;
    const dateOfLoss = submission?.data?.lossDate?.value;
    const vehiclePolicySystemId = submission?.data?.claim_type?.vehicle?.policySystemId;
    const dwellingPolicySystemId = submission?.data?.claim_type?.property?.policySystemId;
    dispatch(createShellClaim(claimId, policyNumber, dateOfLoss, 'digital', preferredLang, vehiclePolicySystemId, dwellingPolicySystemId));
    resolve();
  });

  /**
   * This handler runs after one custom event is triggered
   * The current event data object is persisted on DB and claim status updated
   * @param {Object} event
   */
  const onCustomEvent = (event) => {
    switch (event.type) {
      case events.FORM_EVENT_SAVECONTINUELATER:
        updateHandler(event, events.FORM_EVENT_SAVECONTINUELATER, null, false);
        break;
      case events.FORM_EVENT_PERIODICSAVE:
        updateHandler(event, events.FORM_EVENT_PERIODICSAVE, null, false);
        break;
      case events.FORM_EVENT_LEAVINGPAGE:
        updateHandler(event, events.FORM_EVENT_LEAVINGPAGE, null, false);
        break;
      case events.FORM_OPEN_CHATBOT:
        const chatBot = document.getElementById('five9OpenChatButton');
        if (chatBot) {
          // eslint-disable-next-line no-undef
          Five9ChatSetVariable('Chat.AutoTrigger', true);
          chatBot.click();
        }
        break;
      default:
        break;
    }
  };

  const changeHandler = async (event) => {
    const changedFieldKey = event.changed?.component?.key;
    if (event?.changed?.instance?.path) {
      updateNoteState(event.changed.instance.path);
      setClaimAutoSaved(false);
    }
    switch (changedFieldKey) {
      case 'lossDate':
      case 'claim_type':
        policyHandler(event, changedFieldKey);
        break;
      case 'lossCause':
        // Check if property loss cause is something else
        if (event.changed.value.value === 'other' && !somethingElseSelected) {
          const leavingPageButton = document.querySelectorAll("[name^='data[saveOnLeavingPageButton']")[0];
          leavingPageButton.click();
          somethingElseSelected = true;
          setIsPropertyLossCauseSomethingElse(true);
        } else {
          somethingElseSelected = false;
        }
        break;
      case 'windshieldDamaged':
        // Check if windshield was damaged
        event.changed.value.value === true && setUnibanModalOpen(true);
        break;
      case 'applyThirdParty':
        // Check if lossOfLife selected
        if (wasAnyFatalityModalOpen === false && event.changed.value && event.changed.value.value === 'lossOfLife') {
          wasAnyFatalityModalOpen = true;
          setFatalityModalOpen(true);
        }
        break;
      default:
        break;
    }
  };

  const renderHandler = (event) => {
    policyHandler(event, 'render');
    if (event.component.root.allPages) {
      // Initiate Progress Bar
      setCurrentPageLabel(event.component.component.title);
      setCurrentPage(event.page + 1);
      setTotalPages(event.component.root.allPages.length);
    }
  };

  const policyHandler = async (event, type) => {
    let lossDate;
    let selectedRiskUnit;

    if (type === 'render' && formClaimData?.claim_type) {
      selectedRiskUnit = getRiskUnit(formClaimData.claim_type);
      setRiskUnit(selectedRiskUnit);
    } else if (type === 'lossDate') {
      lossDate = event.changed.value.value.toString();
      lossDate && lastVisitedPage.length <= 0 && (await new Promise((resolve) => {
        dispatch(getPolicyDetails(lossDate, resolve));
      }));
    }
    if (type === 'claim_type' || (type === 'lossDate' && event.data.claim_type?.claim_type)) {
      lossDate = lossDate || event?.data?.lossDate?.value;
      selectedRiskUnit = getRiskUnit(event.data.claim_type);
      setRiskUnit(selectedRiskUnit);
    }
    const selectedPolicy = selectPolicy(selectedRiskUnit, event?.data?.lossDate);
    if (selectedPolicy) {
      window.sessionStorage.setItem('thePolicy', JSON.stringify(selectedPolicy));
      selectedPolicy.properties?.[0].type && window.sessionStorage.setItem('propertyType', getPropertyType(selectedPolicy.properties[0].type));
      window.dispatchEvent(new StorageEvent('storage', { key: 'thePolicy' }));
    }
  };

  // Timeout for GA
  const handleOnIdle = () => {
    if (isIdle()) {
      sendDataToGTM(GA.sendEventData('sessionTimeout', claimData, claimStatus));
      sessionStorage.setItem('timeout', 1);
      pause();
    }
  };

  const { isIdle, pause } = useIdleTimer({
    timeout: 10 * 60000,
    onIdle: handleOnIdle,
    debounce: 1000,
  });

  const closePropertyLossCauseSomethingElseHandler = () => {
    setIsPropertyLossCauseSomethingElse(false);
    const buttonSaveContinueLater = document.querySelector('.btn.save-continue-later');
    if (buttonSaveContinueLater) {
      buttonSaveContinueLater.click();
    }
  };

  const closeUnibanPopUpHandler = () => {
    setUnibanModalOpen(false);
    claimData.auto.data.windshieldDamaged = { value: true };
    saveToDB(sonnetAddressBookUid, claimData, types.CLAIM_STATUS_EXITED, events.FORM_EVENT_SAVECONTINUELATER);
  };

  return (
    props.claims.loading === false && (formClaimData || claimStatus === types.CLAIM_STATUS_INITIATED) && (
      <>
        <FatalityPopUp
          open={isFatalityModalOpen}
          closeFatalityPopUp={() => setFatalityModalOpen(!isFatalityModalOpen)}
        />
        <LeavingTooSoonPopUp
          onClickCancel={updateURL}
          open={isLeavingSoSoonPopUpOpen}
          isClaimAutoSaved={currentPageLabel !== 'Type of claim'}
          closeUserIsLeavingTooSoonPopUp={() => setIsLeavingSoSoonPopUpOpen(!isLeavingSoSoonPopUpOpen)}
          handleOnClickLeave={() => { navigate('/dashboard'); }}
        />
        <UnibanPopUp
          open={isUnibanModalOpen}
          closeUnibanPopUp={() => closeUnibanPopUpHandler()}
        />
        <IncidentAlreadyClaimedPopUp
          open={isIncidentAlreadyClaimedOpen}
          closeIncidentAlreadyClaimedPopUp={() => { dispatch(clearShellClaimDuplicated()); setIsIncidentAlreadyClaimedOpen(!isIncidentAlreadyClaimedOpen); }}
          selectedRiskUnit={riskUnit}
        />
        <SomethingElsePropertyPopUp
          open={isPropertyLossCauseSomethingElse}
          closePropertyLossCauseSomethingElse={() => closePropertyLossCauseSomethingElseHandler()}
        />
        <IdealUserPopUp isClaimAutoSaved={claimAutoSaved} currentPage={currentPage} />
        <div className="claim">
          {currentPageLabel && currentPage > 1 && !isFormioSubmitted && !(!pageIsSet && isResumeClaim) && ( // check for progress not showing on 'start your claim'
            <QuoteProgress
              id="progressBar"
              title={intl.formatMessage({ id: 'Start Claim', defaultValue: 'Start Claim' })}
              stepTitle={intl.formatMessage({ id: currentPageLabel, defaultValue: currentPageLabel })}
              progress={steps[currentPage - 1] && steps[currentPage - 1].progress}
              totalSteps={totalPages}
              primary
              mbXl
            />
          )}
          {render && !isFormioSubmitted && (!isResumeClaim || hasPolicyDetails) && (
            <div className={!pageIsSet && isResumeClaim ? 'form-container-hidden' : ''}>
              <Form
                src={mainForm}
                onFormLoad={() => setIsRendered(true)}
                onRender={renderHandler}
                formReady={instanceHandler}
                onCustomEvent={onCustomEvent}
                options={{
                  readOnly: isReadOnly,
                  i18n: {
                    fr: TranslationsFR,
                    en: TranslationsEN,
                  },
                  language: props.language,
                  hooks: { beforeNext: checkIfClaimIsDuplicated },
                }}
                key={props.language}
              />
            </div>
          )}
          {render && !isFormioSubmitted && isResumeClaim && hasPolicyDetails && !pageIsSet && (
            <div className="loading-overlay">
              <LoadingIndicators.QuoteLoading loading />
            </div>
          )}
          {render && isFormioSubmitted && (!isResumeClaim || hasPolicyDetails) && (
            <Services
              eligibleService={eligibleService}
              claimId={claimId}
              gwclaimId={currentClaim?.gwClaimId}
              audatargetClaimId={currentClaim?.audatargetClaimId}
              claimData={claimData}
              claimStatus={claimStatus}
              submit={(cid) => submitHandler(cid)}
              updateClaim={(data, leave, isServiceUpdate = true) => updateHandler(data, leave ? events.FORM_EVENT_SAVECONTINUELATER : events.FORM_EVENT_NEXT_PAGE, null, isServiceUpdate)}
              currentClaimData={currentClaimData}
              uberAmount={uberAmount}
            />
          )}
          {currentPage === 1 && (
            <div className="small-info">
              <FormattedMessage {...messages.infoSecured} />
            </div>
          )}
        </div>
      </>
    )
  );
}

const mapStateToProps = (state) => ({
  authentication: authenticationDataSelector(state.authentication),
  claims: claimsDataSelector(state.claims),
  claimsGW: gwClaimsDataSelector(state.claims),
  updatedClaim: selectUpdatedClaimSelector(state.claims),
  policyDetails: policyDetailsSelector(state.policyDetails),
  createShellClaim: selectCreatedShellClaimSelector(state.claims),
});

export default connect(mapStateToProps)(FormioComponents);
